import React, { useState, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { MsalProvider, AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import CssBaseline from '@mui/material/CssBaseline';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from './theme/ThemeContext';
import { Layout } from './components/Layout';
import { LoginPage } from './components/LoginPage';
import { getInstance } from './auth/msalInstance';
import { Box, CircularProgress } from '@mui/material';
import type { PublicClientApplication } from "@azure/msal-browser";

const queryClient = new QueryClient();

const App: React.FC = () => {
    const [msalInstance, setMsalInstance] = useState<PublicClientApplication | null>(null);

    useEffect(() => {
        getInstance().then(instance => {
            setMsalInstance(instance);
        });
    }, []);

    if (!msalInstance) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
                <CircularProgress />
            </Box>
        );
    }

    return (
        <ThemeProvider>
            <CssBaseline />
            <QueryClientProvider client={queryClient}>
                <BrowserRouter>
                    <MsalProvider instance={msalInstance}>
                        <AuthenticatedTemplate>
                            <Layout />
                        </AuthenticatedTemplate>
                        <UnauthenticatedTemplate>
                            <LoginPage />
                        </UnauthenticatedTemplate>
                    </MsalProvider>
                </BrowserRouter>
            </QueryClientProvider>
        </ThemeProvider>
    );
};

export default App;
